export function isRangeSelection(
  selection: Selection | null,
): selection is Selection {
  return selection?.type === 'Range';
}

export function addHighlightRange(range: Range, key: string) {
  const highlightRangeSet = CSS.highlights.get(key) ?? new Highlight();
  highlightRangeSet.add(range);
  CSS.highlights.set(key, highlightRangeSet);
}

export function removeHighlightRange(possibleRange: Range, key: string) {
  const highlightRangeSet = CSS.highlights.get(key);
  const existingHighlightRange = findHighlightRange(possibleRange, key);
  if (!highlightRangeSet || !existingHighlightRange) {
    return;
  }

  highlightRangeSet.delete(existingHighlightRange);
  if (highlightRangeSet.size === 0) {
    CSS.highlights.delete(key);
  }
}

export function findHighlightRange(range: Range, key: string) {
  const highlightRangeSet = CSS.highlights.get(key);
  if (!highlightRangeSet) {
    return undefined;
  }

  for (const highlightRange of highlightRangeSet.values()) {
    if (isSameRange(range, highlightRange)) {
      return highlightRange;
    }
  }
  return undefined;
}

function isSameRange(range1: Range, range2: Range) {
  return (
    range1.commonAncestorContainer === range2.commonAncestorContainer &&
    range1.startOffset === range2.startOffset &&
    range1.endOffset === range2.endOffset
  );
}
